import React, { useEffect, useMemo, useRef, useState } from "react";
import AnalysisTable from "./components/AnalysisTable"; // Adjust the import path as needed
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";

import Icon from "@mdi/react";
import { mdiFilterVariant } from "@mdi/js";
import { Tooltip } from "@mui/material";
import { Button } from "react-bootstrap";
import MoreSearchField from "./components/MoreSearchField";

import { fetchProjectCertification } from "../../../redux/slices/projects/analysisTableSlice";
import { setSearchFields } from "../../../redux/slices/certify/certifySlice";
import { getMinistries } from "../../../redux/slices/utilsSlice";

const MainPage = () => {
  // Create a ref for the grid
  const dispatch = useDispatch();
  const gridRef = useRef(null);

  // You might have other state or selectors here
  const { loading, error, rmkActiveApplication, searchFields } = useSelector(
    (state) => ({
      loading: state.analysisTableReducer.loading,
      error: state.analysisTableReducer.error,
      rmkActiveApplication: state.rmkReducer.rmkActiveApplication,
      searchFields: state.certifyReducer.filters.searchFields,
    }),
  );

  const [selectRmk, setSelectRmk] = useState(null);
  const [showCanvas, setShowCanvas] = useState(false);

  const fetchGridData = async () => {
    if (!gridRef.current) return;

    gridRef.current.showLoadingOverlay();

    const props = {
      params: {
        rmk_id: selectRmk?.number,
        ministry_ids: searchFields?.ministries_code || [],
        department_ids: searchFields?.department_ids || [],
        branch_ids: searchFields?.branch_ids || [],
        is_federal_projects:
          JSON.parse(localStorage.getItem("federalProjects"))?.value || false,
      },
    };

    try {
      await dispatch(fetchProjectCertification(props));
      gridRef.current.hideOverlay(); // 👈 Hide after success
    } catch (error) {
      gridRef.current.showNoRowsOverlay(); // 👈 Optional: show error overlay
    }
  };

  const onGridReady = async (params) => {
    gridRef.current = params.api;
    await fetchGridData();
  };

  const handleHideCanvas = () => {
    setShowCanvas(false);
  };

  const handleSearchMoreField = (values) => {
    dispatch(setSearchFields(values));
  };

  useEffect(() => {
    let source = axios.CancelToken.source();

    const initialize = async () => {
      const props = {
        source: source,
      };

      setSelectRmk(rmkActiveApplication);
      await dispatch(getMinistries(props));
    };
    initialize();

    return () => {
      source.cancel();
    };
  }, [dispatch, rmkActiveApplication]);

  useEffect(() => {
    fetchGridData();
  }, [searchFields, selectRmk]);

  return (
    <>
      <MoreSearchField
        showCanvas={showCanvas}
        closeCanvas={handleHideCanvas}
        searchMoreField={handleSearchMoreField}
      />
      <div className='main-page-container' style={{ padding: "20px" }}>
        {/* Status indicators */}
        {loading && <div className='loading-indicator'>Loading data...</div>}
        {error && (
          <div className='error-message' style={{ color: "red" }}>
            {error}
          </div>
        )}

        <div className='d-flex align-items-center gap-2 mb-3 mt-3'>
          <div className='remove-outline-item'>
            <Tooltip title='Lebih Pilihan' placement='top' arrow>
              <Button variant='secondary' onClick={() => setShowCanvas(true)}>
                <Icon path={mdiFilterVariant} size={0.8} />
              </Button>
            </Tooltip>
          </div>
        </div>

        {/* Analysis Table with Excel Export */}
        <AnalysisTable gridRef={gridRef} onGridReady={onGridReady} />
      </div>
    </>
  );
};

export default MainPage;
